import * as Plotly from "plotly.js/dist/plotly-custom.min.js";

const heatmapInit = () => {
  const heatmap = document.querySelector(".js-heatmap");

  if (heatmap) {
    //wait for content to load before pulling data
    document.addEventListener("DOMContentLoaded", () => {
      let xAxisData = document.querySelectorAll(".js-xAxis");
      let yAxisData = document.querySelectorAll(".js-yAxis");
      let monthData = document.querySelectorAll(".js-monthArray");
      let yearData = document.querySelectorAll(".js-yearArray");

      //sort twig data
      const xArray = [];
      let xValues;
      const yArray = [];
      let yValues;
      const monthArray = [];
      let monthValues;
      const yearArray = [];
      let yearValues;

      xAxisData.forEach((el) => {
        xArray.push(JSON.parse(el.dataset.set));
      });

      xValues = xArray
        .map((el) =>
          el.reverse().map((e) => {
            return e.title;
          })
        )
        .reverse();

      yAxisData.forEach((el) => {
        yArray.push(JSON.parse(el.dataset.set));
      });

      yValues = yArray
        .map((el) =>
          el
            .map((e) => {
              return e.title;
            })
            .slice(0, 4)
            .reverse()
        )
        .reverse();

      monthData.forEach((el) => {
        monthArray.push(el.dataset.set);
      });

      monthValues = monthArray.map((month) =>
        JSON.parse(month).map((value) => parseInt(value))
      );

      yearData.forEach((el) => {
        yearArray.push(el.dataset.set);
      });

      yearValues = yearArray.map((year) =>
        JSON.parse(year).map((value) => parseInt(value))
      );

      //helper functions
      const sortUnique = (arr) => {
        const unique = [...new Set(arr)];
        return unique;
      };

      const seperateArray = (array) => {
        const values = [];
        for (let x = 0; array.length > x; x++) {
          values.push(array.splice(0, 4).reverse());
        }
        return values;
      };

      function transpose(a) {
        return Object.keys(a[0]).map(function (c) {
          return a.map(function (r) {
            return r[c];
          });
        });
      }

      //plotly
      var colorscaleValueBlue = [
        [0, "#F2FAFF"],
        [0.25, "#D5EEFD"],
        [0.5, "#B2E2FF"],
        [0.75, "#61BBF2"],
        [1, "#0075BE"],
      ];

      var colorscaleValueGreen = [
        [0, "#FCFCFD"],
        [0.25, "#E1FAF6"],
        [0.5, "#91F2E1"],
        [0.75, "#73E5D2"],
        [1, "#39D4B9"],
      ];

      const zValuesMonthly = [
        seperateArray(monthValues[1]).reverse(),
        seperateArray(monthValues[0]).reverse(),
      ];
      const zValuesYearly = [
        seperateArray(yearValues[1]).reverse(),
        seperateArray(yearValues[0]).reverse(),
      ];

      var dataMonthlyEquity = [
        {
          z: transpose(zValuesMonthly[1]),
          x: sortUnique(xValues[1]),
          y: yValues[1],
          type: "heatmap",
          colorscale: colorscaleValueBlue,
          hovertemplate: "$%{z}<extra></extra>",
          showscale: false,
        },
      ];

      var dataYearlyEquity = [
        {
          z: transpose(zValuesYearly[1]),
          x: sortUnique(xValues[1]),
          y: yValues[1],
          type: "heatmap",
          colorscale: colorscaleValueBlue,
          hovertemplate: "$%{z}<extra></extra>",
          showscale: false,
        },
      ];

      var dataMonthlyFixed = [
        {
          z: transpose(zValuesMonthly[0]),
          x: sortUnique(xValues[0]),
          y: yValues[0],
          type: "heatmap",
          colorscale: colorscaleValueGreen,
          hovertemplate: "$%{z}<extra></extra>",
          showscale: false,
        },
      ];

      var dataYearlyFixed = [
        {
          z: transpose(zValuesYearly[0]),
          x: sortUnique(xValues[0]),
          y: yValues[0],
          type: "heatmap",
          colorscale: colorscaleValueGreen,
          hovertemplate: "$%{z}<extra></extra>",
          showscale: false,
        },
      ];

      var layout = {
        title: "",
        annotations: [],
        xaxis: {
          ticks: " ",
          side: "bottom",
          fixedrange: true,
        },
        yaxis: {
          ticks: "",
          ticksuffix: " ",
          height: 700,
          fixedrange: true,
        },
      };

      Plotly.newPlot("heatmap-month-equity", dataMonthlyEquity, layout);
      Plotly.newPlot("heatmap-year-equity", dataYearlyEquity, layout);
      Plotly.newPlot("heatmap-month-fixed", dataMonthlyFixed, layout);
      Plotly.newPlot("heatmap-year-fixed", dataYearlyFixed, layout);
    });
  }
};

heatmapInit();
